module.exports = __webpack_public_path__ + "static/media/tubes-2.89b868e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeView/tubes-2.png
// module id = 452
// module chunks = 0